export const holidayOptions = [
  { id: 'new_years_day', name: "New Year's Day" },
  { id: 'valentines_day', name: "Valentine's Day" },
  { id: 'international_womens_day', name: "International Women's Day" },
  { id: 'st_patricks_day', name: "St. Patrick's Day" },
  { id: 'easter', name: 'Easter' },
  { id: 'passover', name: 'Passover' },
  { id: 'administrative_professionals_day', name: 'Administrative Professionals Day' },
  { id: 'mothers_day', name: "Mother's Day" },
  { id: 'memorial_day', name: 'Memorial Day' },
  { id: 'rose_month', name: 'Rose Month' },
  { id: 'fathers_day', name: "Father's Day" },
  { id: 'fourth_of_july', name: '4th of July' },
  { id: 'friendship_day', name: 'Friendship Day' },
  { id: 'labor_day', name: 'Labor Day' },
  { id: 'grandparents_day', name: 'Grandparents Day' },
  { id: 'rosh_hashanah', name: 'Rosh Hashanah' },
  { id: 'boss_day', name: "Boss's Day" },
  { id: 'sweetest_day', name: 'Sweetest Day' },
  { id: 'halloween', name: 'Halloween' },
  { id: 'thanksgiving', name: 'Thanksgiving' },
  { id: 'hanukkah', name: 'Hanukkah' },
  { id: 'christmas', name: 'Christmas' },
  { id: 'kwanzaa', name: 'Kwanzaa' },
]

export const holidayLabelsById = Object.fromEntries(
  holidayOptions.map((option) => [option.id, option.name])
)
